import { constantRoutes } from '@/router' // router,asyncRoutes,resetRouter
import { getDefaultCur, getAllPermission } from '@/utils/auth'
import { transRouteData } from '@/store/modules/user'
// import Layout from '@/layout'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}
// export function transRouteData (routers) {
//   const aRouter = []
//   routers.forEach(oMenu => {
//     const {
//       path,
//       commponent,
//       name,
//       icon,
//       children
//     } = oMenu
//     if(!validatenull(component)) {
//       let filePath
//       const oRouter = {
//         path: path,
//         component(resolve) {
//           let componentPath = ''
//           if (component == Layout) {
//             require(['../views/layout/Layout'], resolve)
//             return
//           } else {
//             componentPath = component
//           }
//           require([`../${componentPath}.vue`], resolve)
//         }
//       }
//     }
//   })
// }

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit }, roles) {
    return new Promise(async resolve => {
      let accessedRoutes
      // console.log(getAllPermission()[getDefaultCur()].router)
      let _asyncRoutes = await transRouteData(getAllPermission()[getDefaultCur()].router)
      // console.log(_asyncRoutes, 88)
      // if (roles.includes('admin')) {
      //   accessedRoutes = asyncRoutes || []
      // } else {
      accessedRoutes = filterAsyncRoutes(_asyncRoutes, roles)
      // }
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  },
  autoGenerateRoutes({ commit }, newRouter) {
    return new Promise(resolve => {
      // 最后添加
      let unfound = { path: '*', redirect: '/dashboard', hidden: true }
      newRouter.push(unfound)
      commit('SET_ROUTES', newRouter)
      resolve(newRouter)
    })
  },
  setNewRoutes({ commit }, newRouter) {
    commit('SET_ROUTES', newRouter)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
